import React, { useState } from "react";
import ImagePopup from "./ImagePopup";

function OrganizationCard({
  organization,
  objective,
  verificationDate,
  imageUrl,
  link,
  source,
  phone,
  buttonText = "Cliquez ici pour accéder au lien",
}) {
  const [showPopup, setShowPopup] = useState(false);

  const handleCardClick = () => {
    if (link) {
      window.open(link, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <div
      className="card grey-box"
      // onClick={handleCardClick}
      style={{ cursor: link ? "pointer" : "default" }}
    >
      {imageUrl && (
        <div className="card-image-container" style={{ height: "30%" }}>
          <img
            src={imageUrl}
            alt={organization}
            className="card-image"
            style={{ cursor: "pointer" }}
          />
        </div>
      )}
      <div
        className="card-content"
        style={{ height: "70%", display: "flex", flexDirection: "column" }}
      >
        <h2 style={{ marginTop: 0, marginBottom: 10 }}>{organization}</h2>
        <p style={{ textAlign: "justify" }}>{objective}</p>
        {phone && <p className="phone">{phone}</p>}
        <div style={{ marginTop: "auto" }}>
          {link && (
            <button
              className="custom-link-button"
              onClick={(e) => {
                e.stopPropagation();
                window.open(link, "_blank", "noopener,noreferrer");
              }}
            >
              {buttonText}
            </button>
          )}
          <p className="verification-date" style={{ marginBottom: 0 }}>
            Vérifié le : {verificationDate}
          </p>
          {source && (
            <p className="source">
              Source :{" "}
              <a href={source} target="_blank" rel="noopener noreferrer">
                Voir la source
              </a>
            </p>
          )}
        </div>
      </div>

      {showPopup && (
        <ImagePopup
          imageUrl={imageUrl}
          organization={organization}
          objective={objective}
          verificationDate={verificationDate}
          onClose={() => setShowPopup(false)}
        />
      )}
    </div>
  );
}

export default OrganizationCard;
